import { PagePathFactory } from 'constants/pagePath';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IssuanceDocumentFolderInfo, useGetIssuanceDocumentFolderListQuery } from 'views/utils/graphql/graphql';

interface IIssuanceDocumentFromId {
  kind: 'id';
  folderId: string | null;
}

// 銘柄名で検索
interface IIssuanceDocumentFromSymbolName {
  kind: 'symbolName';
  folderId: string | null;
  symbolName: string;
}

export type IssuanceDocumentProps = IIssuanceDocumentFromId | IIssuanceDocumentFromSymbolName;

export const enum DocumentPageType {
  Folder,
  File,
}

export const useIssuanceDocument = (props: IssuanceDocumentProps) => {
  const params = useMemo(() => {
    switch (props.kind) {
      case 'id':
        return {
          folderId: props.folderId,
          searchKeyWord: '',
        };
      case 'symbolName':
        return {
          folderId: props.folderId,
          searchKeyWord: props.symbolName,
        };
    }
  }, [props]);

  const [documentFolderList, _] = useGetIssuanceDocumentFolderListQuery({
    variables: {
      id: params.folderId,
      count: 100,
      page: 1,
    },
    requestPolicy: 'network-only',
  });

  const navigate = useNavigate();

  const onFolderSelect = useCallback(
    (folder: IssuanceDocumentFolderInfo) => {
      navigate(PagePathFactory.issuanceDocumentFromFolderId(folder.ID));
    },
    [navigate],
  );

  const documentPageType = useMemo<DocumentPageType>(() => {
    if (documentFolderList.fetching) return DocumentPageType.Folder;

    const ownFolder = documentFolderList.data?.GetIssuanceDocumentFolderList?.Own;
    if (ownFolder) {
      return ownFolder.HasChildFolder ? DocumentPageType.Folder : DocumentPageType.File;
    } else {
      return DocumentPageType.Folder;
    }
  }, [documentFolderList]);

  return {
    currentFolderId: params.folderId,
    currentFolderName: params.folderId
      ? documentFolderList.data?.GetIssuanceDocumentFolderList?.Own?.Name || ''
      : '交付書面',
    searchKeyWord: params.searchKeyWord,
    documentPageType,
    documentFolderList,
    onFolderSelect,
  };
};
